import type React from "react";
import styles from "./index.module.scss";

interface CommonButtonProps {
  children?: React.ReactNode;
  icon?: React.ReactNode;
  variant?: "filled" | "icon" | "label" | "diff-approve" | "diff-reject" | "diff-edit";
  onClick?: () => void;
  type?: "button" | "submit";
  className?: string;
  disabled?: boolean;
  labelClassName?: string;
  "data-testid"?: string;
}

const variantClassMap = {
  filled: styles["filled"],
  icon: styles["icon"],
  label: styles["onlyLabel"],
  "diff-approve": styles["diffApprove"],
  "diff-reject": styles["diffReject"],
  "diff-edit": styles["diffEdit"],
};

export const CommonButton: React.FC<CommonButtonProps> = ({
  children,
  icon,
  variant = "filled",
  onClick,
  type = "button",
  className = "",
  labelClassName = "",
  disabled = false,
  "data-testid": dataTestId,
}) => {
  const buttonClass = `${variantClassMap[variant]} ${className}`.trim();

  return (
    <button
      type={type}
      onClick={onClick}
      className={buttonClass}
      disabled={disabled}
      data-testid={dataTestId}
    >
      {variant !== "label" && icon && <span className={styles["iconWrapper"]}>{icon}</span>}
      {(variant === "filled" || variant === "label" || variant?.startsWith("diff-")) &&
        children && <span className={`${styles["label"]} ${labelClassName}`}>{children}</span>}
    </button>
  );
};
